import React from "react";
import { ReactComponent as Warning } from "../../../../assets/icons/Warning.svg";

// TIP-464 — Simplified banner: shows when the user has no active Verified
// Company subscription. The legacy Sumsub PENDING/FAILED/IN_PROGRESS state
// machine is gone (Sumsub isn't wired in production right now).
export const VerificationBanner = ({ onClick }) => {
  return (
    <div className="bg-warning border-warning border rounded-lg p-3 mb-5 text-left text-warning flex gap-3 items-center text-f16">
      <Warning />
      <span>
        Your business isn't Verified yet.{" "}
        <span
          onClick={onClick}
          className="text-primaryText font-semibold cursor-pointer"
        >
          Click here
        </span>{" "}
        to upgrade and unlock the Verified badge.
      </span>
    </div>
  );
};
